export const enum StyledGateModalVariant {
  CHANGE_STYLE = 'CHANGE_STYLE',
}
